import { type FunctionComponent, useEffect } from 'react';
import useScript from 'react-script-hook';
import { type ImageFieldsFragment } from '../../../__generated__/graphql-client-types';
import { type CloudinaryOptions } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { Modal } from '../modal/modal.component';

type ThreeSixtyImageProps = {
	id: string;
	image: ImageFieldsFragment;
	className?: string;
	options: CloudinaryOptions;
};

type TriggerElementProps = {
	image: ImageFieldsFragment;
	className?: string;
	options: CloudinaryOptions;
};

const TriggerElement: FunctionComponent<TriggerElementProps> = ({ image, className = '', options }) => (
	<div className="relative">
		<CloudinaryImage
			limitHeight={true}
			publicID={image.id}
			description="three sixty image"
			options={{ type: 'upload', ...options }}
			className={className}
		/>
		<span
			className="absolute tc br2 inline normal theme-white pa2 bg-theme-grey o-90"
			style={{
				top: '55%',
				left: '50%',
				margin: 'auto',
				transform: 'translate(-50%, 0)'
			}}>
			Click to Spin
		</span>
	</div>
);

export const ThreeSixtyImage: FunctionComponent<ThreeSixtyImageProps> = ({ id, image, className, options }) => {
	return (
		<Modal
			triggerElement={<TriggerElement image={image} className={className} options={options} />}
			title={<></>}
			ariaLabel="Three Sixty Image Modal">
			<ThreeSixtyModal id={id} />
		</Modal>
	);
};

const ThreeSixtyModal: FunctionComponent<{ id: string }> = ({ id }) => {
	const [loading, error] = useScript({
		src: 'https://product-gallery.cloudinary.com/1.1.8/all.js'
	});

	const CONTAINER_ID = 'threesixty-gallery-modal';

	useEffect(() => {
		if (!loading && !error && window.cloudinary) {
			const threeSixtyGallery = window.cloudinary.galleryWidget({
				cloudName: 'build',
				container: `#${CONTAINER_ID}`,
				secure: true,
				privateCdn: true,
				aspectRatio: '1:1',
				loaderProps: {
					style: 'circle'
				},
				carouselStyle: 'none',
				zoom: false,
				spinProps: {
					tipText: 'Drag to Rotate'
				},
				mediaAssets: [
					{
						tag: id,
						mediaType: 'spin'
					}
				]
			});

			threeSixtyGallery.render();
		}
	}, [loading, error]);

	return <div style={{ minHeight: '50px', minWidth: '50px' }} id={CONTAINER_ID} data-testid="threesixty modal display" />;
};
